import { useAtomValue } from 'jotai'
import React from 'react'
import { useMount } from 'react-use'

import {
  FilterInformation,
  type FilterInformationProps,
} from '~/components/features/FilterInformation'
import { RichSurveyGroupFilterGroupsDisplay } from '~/components/features/RichSurveyGroupFilterGroupsDisplay'
import { type SurveyGroupFilterGroups } from '~/utils'

import { isVisibleEditDialogAtom, onChangeAtom } from '../atoms'
import {
  useMainQueryBrands,
  useMainQueryCustomerAttributeGroups,
  useMainQueryQuestions,
} from '../hooks/useMainQuery'

import { EditSurveyGroupFilterDialog } from './EditSurveyGroupFilterDialog'

export type SurveyGroupFilterInformationContentProps = {
  className?: string
  filterGroups: SurveyGroupFilterGroups
  onReady?: (questions: ReturnType<typeof useMainQueryQuestions>) => void
}

export const SurveyGroupFilterInformationContent = ({
  className,
  filterGroups,
  onReady,
}: SurveyGroupFilterInformationContentProps) => {
  const brands = useMainQueryBrands()
  const customerAttributeGroups = useMainQueryCustomerAttributeGroups()
  const questions = useMainQueryQuestions()

  const isFiltered = React.useMemo(
    () => 0 < filterGroups.length,
    [filterGroups.length],
  )

  const onChange = useAtomValue(onChangeAtom)
  const handleClear = React.useCallback<
    EH<FilterInformationProps, 'onClear'>
  >(() => {
    onChange(undefined)
  }, [onChange])

  useMount(() => {
    onReady?.(questions)
  })

  return (
    <FilterInformation
      className={className}
      editDialog={<EditSurveyGroupFilterDialog filterGroups={filterGroups} />}
      filterDisplay={
        <RichSurveyGroupFilterGroupsDisplay
          brands={brands}
          customerAttributeGroups={customerAttributeGroups}
          filterGroups={filterGroups}
          questions={questions}
        />
      }
      isFiltered={isFiltered}
      isVisibleEditDialogAtom={isVisibleEditDialogAtom}
      onClear={handleClear}
    />
  )
}
